import React from 'react';
import { CalendarContainer } from 'react-datepicker-isobar';
import { i18n } from 'utils/i18n';
import cn from 'classnames';
import Button from 'components/Button';

const CustomContainer = React.forwardRef((props, ref) => {
  const {
    className,
    children,
    helpText,
    handleClose,
    isMobile,
    showGuidedError,
    renderGuidedError,
    smallWrapper,
    timeAndDatePickerFullHeight,
    contractRestrictions,
    isRental,
  } = props;

  return (
    <div
      className={cn('react-datepicker__custom-wrapper component-theme--light', {
        'react-datepicker__custom-wrapper--half-width': smallWrapper,
        'react-datepicker__custom-wrapper--full-height': timeAndDatePickerFullHeight,
      })}
    >
      {(helpText || showGuidedError || isMobile) && (
        <div className='react-datepicker__messaging'>
          {showGuidedError && renderGuidedError()}
          {!showGuidedError && helpText && (
            <>
              <div className='react-datepicker__help-message'>{helpText}</div>
              {contractRestrictions && <div className='react-datepicker__special-label'>{i18n('common_special')}</div>}
            </>
          )}
          {isMobile && (
            <Button
              plain
              className='react-datepicker__close'
              onClick={handleClose}
              type='button'
              aria-label={i18n('common_close')}
            >
              {i18n('common_close')}
            </Button>
          )}
        </div>
      )}
      <CalendarContainer className={className}>
        {children}
        <span className='scroll-reference' ref={ref} />
      </CalendarContainer>
      {isRental && (
        <div className='react-datepicker__rental-footer'>
          <div>
            <span className='react-datepicker__today-icon'>##</span>
            {i18n('todays_date')}
          </div>
          <div>
            <span className='react-datepicker__exceeds-icon'>##</span>
            {i18n('date_exceeds_max_duration_rental')}
          </div>
        </div>
      )}
    </div>
  );
});

export default CustomContainer;
